import React from "react";
import { Box, Typography, Container } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        mt: 3,
        pt: 2,
        pb: 3,
        px: 2,
        backgroundColor: "primary.main",
        textAlign: "center",
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" color="primary.contrastText">
          Created by David Topalov 2026. This is a beta version. The application is not production ready
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
